/** @jsx jsx */
import { jsx } from '@emotion/core';

export default function Header({ text, styles }) {
  return <h1 css={[{ fontWeight: 600, fontSize: 24 }, styles]}>{text}</h1>;
}
